import React from 'react';
import {PLAY__24} from '@homeaway/svg-defs';
import {ButtonIcon} from '@homeaway/react-buttons';
import WithModal from 'ui/WithModal';
import IFrame from 'ui/IFrame/IFrame';
import Raw from 'ui/Raw/Raw';
import './PerksList.less';

const PerksList = ({perks}) => (
    <div className="perks-list">
        {perks.map((perk, index) => (
            <div className="perk" key={`perk-${index}`}>
                {perk.videoId ? (
                    <WithModal
                        id="perks-video"
                        modalContent={
                            <IFrame
                                src={`https://www.youtube.com/embed/${
                                    perk.videoId
                                }`}
                            />
                        }
                    >
                        {(handleOpen) => (
                            <div className="perks-video">
                                <ButtonIcon
                                    svgMarkup={PLAY__24}
                                    label="Play video"
                                    onClick={handleOpen}
                                    inverse
                                    circle
                                    size="lg"
                                />
                                <img
                                    src={
                                        perk.imageUrl ||
                                        `//img.youtube.com/vi/${
                                            perk.videoId
                                        }/hqdefault.jpg`
                                    }
                                    alt=""
                                    className="img-responsive"
                                />
                            </div>
                        )}
                    </WithModal>
                ) : (
                    <img
                        src={perk.imageUrl}
                        alt=""
                        className="img-responsive"
                    />
                )}

                <h4>{perk.title || perk.subTitle}</h4>
                <Raw content={perk.body} />
            </div>
        ))}
    </div>
);

export default PerksList;
